import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

const setFoerderbuddyBrowserChrome = () => {
  document.title = 'Förderbuddy';

  document
    .querySelectorAll("link[rel*='icon']")
    .forEach((link) => link.parentNode?.removeChild(link));

  const cacheKey = Date.now();
  const favicons = [
    { rel: 'icon', type: 'image/svg+xml', href: `/foerderbuddy-logo.svg?v=${cacheKey}` },
    { rel: 'shortcut icon', href: `/favicon.ico?v=${cacheKey}` },
    { rel: 'apple-touch-icon', href: `/logo192.png?v=${cacheKey}` },
  ];

  favicons.forEach((config) => {
    const link = document.createElement('link');
    Object.entries(config).forEach(([key, value]) => {
      link.setAttribute(key, value);
    });
    document.head.appendChild(link);
  });
};

setFoerderbuddyBrowserChrome();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const pendingWebVitals = [];
let webVitalsFlushTimer = null;

const recordWebVital = (metric) => {
  if (!window.sessionStorage.getItem('foerderbuddyAuthToken')) return;

  pendingWebVitals.push({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    route: window.location.pathname
  });

  if (webVitalsFlushTimer) return;
  webVitalsFlushTimer = window.setTimeout(() => {
    const metrics = pendingWebVitals.splice(0, pendingWebVitals.length);
    webVitalsFlushTimer = null;
    if (metrics.length === 0) return;
    axios.post('/api/performance/web-vitals', { metrics }).catch(() => {});
  }, 2000);
};

reportWebVitals(recordWebVital);
